import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3534a5d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users p-20 flex column gap-12 overflow-hidden" }
const _hoisted_2 = { class: "office-list flex column overflow-hidden gap-20 overflow-hidden" }
const _hoisted_3 = { class: "ops flex align-center" }
const _hoisted_4 = { class: "office overflow-overlay flex column gap-8" }
const _hoisted_5 = { class: "rows flex column flex-1 gap-8" }
const _hoisted_6 = { class: "row flex align-center gap-8" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text nowrap-text" }, "辦公室名稱", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text nowrap-text" }, "地址", -1))
const _hoisted_9 = { class: "row flex align-center gap-8" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text nowrap-text" }, "電話", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text nowrap-text" }, "傳真", -1))
const _hoisted_12 = { class: "office-list flex column overflow-hidden gap-20 overflow-hidden" }
const _hoisted_13 = { class: "ops flex align-center" }
const _hoisted_14 = { class: "office overflow-overlay flex column gap-8" }
const _hoisted_15 = { class: "rows flex column flex-1 gap-8" }
const _hoisted_16 = { class: "row flex align-center gap-8" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text nowrap-text" }, "資訊", -1))
const _hoisted_18 = { class: "row flex align-center gap-8" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text nowrap-text" }, "電話", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space flex-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "form full-page flex column p-20 overflow-overlay",
      ref: "form",
      model: _ctx.form,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "Email" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "網站" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.website,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.website) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "form-item flex align-stretch overflow-hidden",
          label: "辦公室設定"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.addOffice
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增辦公室")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offices, (data, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "office-item flex align-center gap-20 p-8",
                    key: idx
                  }, [
                    _createVNode(_component_el_popconfirm, {
                      "confirm-button-text": "確認",
                      "cancel-button-text": "取消",
                      title: "確認要刪除該辦公室？",
                      onConfirm: ($event: any) => (_ctx.deleteOffice(idx))
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "danger",
                          size: "mini",
                          icon: _ctx.Delete
                        }, null, 8, ["icon"])
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_component_el_input, {
                          class: "input",
                          modelValue: data.name,
                          "onUpdate:modelValue": ($event: any) => ((data.name) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _hoisted_8,
                        _createVNode(_component_el_input, {
                          class: "input",
                          modelValue: data.address,
                          "onUpdate:modelValue": ($event: any) => ((data.address) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_el_input, {
                          class: "input",
                          modelValue: data.phone,
                          "onUpdate:modelValue": ($event: any) => ((data.phone) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _hoisted_11,
                        _createVNode(_component_el_input, {
                          class: "input",
                          modelValue: data.fax,
                          "onUpdate:modelValue": ($event: any) => ((data.fax) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "form-item flex align-stretch overflow-hidden",
          label: "中國辦公室設定"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.addChinaOffice
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增中國辦公室")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chinaOffices, (data, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "office-item flex align-center gap-20 p-8",
                    key: idx
                  }, [
                    _createVNode(_component_el_popconfirm, {
                      "confirm-button-text": "確認",
                      "cancel-button-text": "取消",
                      title: "確認要刪除該辦公室？",
                      onConfirm: ($event: any) => (_ctx.deleteChinaOffice(idx))
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "danger",
                          size: "mini",
                          icon: _ctx.Delete
                        }, null, 8, ["icon"])
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode(_component_el_input, {
                          class: "input",
                          type: "textarea",
                          modelValue: data.address,
                          "onUpdate:modelValue": ($event: any) => ((data.address) = $event),
                          autosize: { minRows: 4, maxRows: 6 }
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(_component_el_input, {
                          class: "input",
                          modelValue: data.phone,
                          "onUpdate:modelValue": ($event: any) => ((data.phone) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _hoisted_20,
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.save
            }, {
              default: _withCtx(() => [
                _createTextVNode("儲存")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, { onClick: _ctx.reset }, {
              default: _withCtx(() => [
                _createTextVNode("重設")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}